import { Component, OnInit, ViewChild } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { CalendarModalOptions, CalendarModal } from "ion2-calendar";
import * as moment from "moment";
import { AvaliacaoRacService } from "src/services/avaliacao-rac.service";
import { AutocompleteSelectorComponent } from "../autocomplete-selector/autocomplete-selector.component";

@Component({
  selector: "app-atestados-list-component",
  templateUrl: "./atestados-list-component.component.html",
  styleUrls: ["./atestados-list-component.component.scss"],
})
export class AtestadosListComponentComponent implements OnInit {
  @ViewChild("cnesFilterSelector")
  cnesFilterSelector: AutocompleteSelectorComponent;
  @ViewChild("cidFilterSelector")
  cidFilterSelector: AutocompleteSelectorComponent;
  @ViewChild("procedimentoFilterSelector")
  procedimentoFilterSelector: AutocompleteSelectorComponent;
  @ViewChild("caraterAtendimentoFilterSelector")
  caraterAtendimentoFilterSelector: AutocompleteSelectorComponent;

  atestadosList: any = [];
  atestadosListFiltered: any = [];

  dtInicio: any;
  dtFim: any;
  procedimentosData: any = [];
  caraterAtendimentoData: any = [];
  cnesData: any = [];
  cidData: any = [];

  cnesFilter: any;
  cidFilter: any;

  userFiltro: any;
  procedimentoSelecionado: any;
  caraterSelecionado: any;

  emptyState = {
    imgUrl: "/assets/imgs/bg-atestados.svg",
    title: "Você ainda não tem nenhum registro de atestado.",
    text: "Os atestados são registros advindos dos atendimentos realizados nos estabelecimentos de saúde que enviam dados para Rede Nacional de Dados em Saúde (RNDS), caso haja um atestado vinculado ao atendimento, ele será apresentado.",
  };

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private racService: AvaliacaoRacService,
    private toastController: ToastController
  ) {}

  async ngOnInit() {
    await this.loadData();
  }

  async loadData() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    try {
      const atendimentosList = await this.racService.getList();
      this.atestadosList = atendimentosList.filter(
        (a) => a.atestados.length > 0
      );
      if (this.atestadosList) {
        await this.loadFilter();
        await this.filter();
      }
    } catch (e) {
      console.error("error", e);
    }
    await loading.dismiss();
  }

  get cnesDataDisplay() {
    return this.cnesData.map((cnes) => cnes.display);
  }
  get cidDataDisplay() {
    return this.cidData.map((cid) => cid.display);
  }

  async loadFilter() {
    this.atestadosList.forEach((rac) => {
      if (
        this.cnesData.findIndex((cnes: any) => cnes.coCnes === rac.coCnes) ===
        -1
      )
        this.cnesData.push({
          coCnes: rac.coCnes,
          nmEstabelecimento: rac.nmEstabelecimento,
          display: `${rac.coCnes} - ${rac.nmEstabelecimento}`,
        });
      rac.atestados.forEach((atestado) => {
        atestado.diagnostico.forEach((diag: any) => {
          if (
            diag.CID10 !== "-" &&
            this.cidData.findIndex((cid: any) => cid.CID10 === diag.CID10) ===
              -1
          )
            this.cidData.push({
              CID10: diag.CID10,
              nmCID10: diag.nmCID10,
              display: `${diag.CID10} - ${diag.nmCID10}`,
            });
        });
      });
      rac.procedimentos.forEach((procedimento) => {
        if (
          this.procedimentosData.findIndex(
            (proc: any) => proc === procedimento.nome
          ) === -1
        )
          this.procedimentosData.push(procedimento.nome);
      });
      if (
        this.caraterAtendimentoData.findIndex(
          (carater: any) => carater === rac.caraterAtendimento
        ) === -1
      )
        this.caraterAtendimentoData.push(rac.caraterAtendimento);
    });
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field) {
    this[field] = null;
    await this.filter();
  }

  async clearFilter() {
    this.dtInicio = null;
    this.dtFim = null;
    this.cnesFilter = null;
    this.cidFilter = null;
    this.procedimentoSelecionado = null;
    this.caraterSelecionado = null;
    await this.cnesFilterSelector.clearQuery();
    await this.cidFilterSelector.clearQuery();
    await this.procedimentoFilterSelector.clearQuery();
    await this.caraterAtendimentoFilterSelector.clearQuery();
  }

  async select(event, type) {
    this[type] = event;
    await this.filter();
  }

  async filter() {
    Object.assign(this.atestadosListFiltered, this.atestadosList);

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.atestadosListFiltered = this.atestadosListFiltered.filter(atendimento => {
          const dtAtendimento = moment(atendimento.dtAtendimento, "DD/MM/YYYY");
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, 'd');
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, 'd');
          return dtAtendimento.isBetween(dtInicio, dtFim);
      });
  }

    if (this.cnesFilter) {
      this.atestadosListFiltered = this.atestadosListFiltered.filter(
        (atendimento) => {
          const coCnes = this.cnesData.find(cnes => cnes.display === this.cnesFilter).coCnes
          return atendimento.coCnes === coCnes;
        }
      );
    }

    if (this.cidFilter) {
      const CID10  = this.cidData.find(cid => cid.display === this.cidFilter).CID10;
      this.atestadosListFiltered = this.atestadosListFiltered.filter(
        (atendimento) => {
          return atendimento.atestados.filter((atestado) => {
            return atestado.diagnostico.filter((diagnostico) => {
              return (diagnostico.CID10 === CID10);
            })
          });
          
        }
      );
    }

    if (this.procedimentoSelecionado) {
      this.atestadosListFiltered = this.atestadosListFiltered.filter(
        (atendimento) => {
          return atendimento.procedimentos.find(
            (procedimento) =>
              procedimento.nome.toLowerCase() ===
              this.procedimentoSelecionado.toLowerCase()
          );
        }
      );
    }

    if (this.caraterSelecionado) {
      this.atestadosListFiltered = this.atestadosListFiltered.filter(
        (atendimento) => {
          return (
            atendimento.caraterAtendimento.toLowerCase() ===
            this.caraterSelecionado.toLowerCase()
          );
        }
      );
    }
  }

  abrirItem(rac, atestado) {
    const current =
      this.atestadosListFiltered[rac].atestados[atestado].selecionado;
    this.atestadosListFiltered.forEach((rac) => {
      rac.atestados.forEach((atest) => {
        atest.selecionado = false;
      });
    });
    this.atestadosListFiltered[rac].atestados[atestado].selecionado = !current;
  }
}
